import axios from '../../helpers/interceptors';

import {
    TEST,
    REGISTRATION_STARTED,
    REGISTRATION_SUCCESS,
    REGISTRATION_FAILURE,
    LOGIN_STARTED,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    SET_AUTHORIZATION_STATUS,
    SET_TOKEN_STATUS,
    SET_INVITATION_CODE_STARTED,
    SET_INVITATION_CODE_SUCCESS,
    SET_INVITATION_CODE_FAILURE,
    LOGOUT_STARTED,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
    RESEND_EMAIL_STARTED,
    RESEND_EMAIL_SUCCESS,
    RESEND_EMAIL_FAILURE,
    FORGOT_PASSWORD_STARTED,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    RESET_PASSWORD_STARTED,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    LOGIN_2FA_RESET,
    LOGIN_2FA_VERIFY_STARTED,
    LOGIN_2FA_VERIFY_SUCCESS,
    LOGIN_2FA_VERIFY_FAILURE,
    LOGIN_2FA_REQUIRED
} from "./types";

import {api} from "../../api";
// // axios.defaults.withCredentials = true;
const host = api.host;


export const test = data => ({
    type: TEST,
    payload: data
});

export const setAuthorizationStatus = status => ({
    type: SET_AUTHORIZATION_STATUS,
    payload: status
});

export const setTokenStatus = status => ({
    type: SET_TOKEN_STATUS,
    payload: status
});



export const registration = (formData, successHandler) => {
    let url = host + api.registration;

    return dispatch => {
        dispatch(registrationStarted());
        axios.post(url, formData)
            .then(res => {
                localStorage.setItem('b-token', res.data.response.token);
                dispatch(registrationSuccess(res.data.response));
                dispatch(setTokenStatus(true));
                successHandler();
            })
            .catch(err => {
                dispatch(registrationFailure(err?.response?.data?.errors));
            });
    };
};

const registrationStarted = () => ({
    type: REGISTRATION_STARTED
});

export const registrationSuccess = serverReport => ({
    type: REGISTRATION_SUCCESS,
    payload: serverReport
});

export const registrationFailure = error => ({
    type: REGISTRATION_FAILURE,
    payload: error
});


export const login = (formData) => {
    let url = host + api.login;

    return dispatch => {
        dispatch(loginStarted());

        axios.post(url, formData)
            .then(res => {
                const response = res.data.response;

                if (response?.two_factor_required && response?.challenge_token) {
                    dispatch(login2faRequired({
                        challenge_token: response.challenge_token,
                        expires_in: response.expires_in,
                    }));

                    return;
                }

                localStorage.setItem('b-token', response.token);
                localStorage.setItem('b-auth-status', 'true');

                dispatch(loginSuccess(response));
                dispatch(setTokenStatus(true));
            })
            .catch(err => {
                dispatch(loginFailure(err?.response?.data?.errors));
            });
    };
};

const loginStarted = () => ({
    type: LOGIN_STARTED
});

export const loginSuccess = serverReport => ({
    type: LOGIN_SUCCESS,
    payload: serverReport
});

export const loginFailure = error => ({
    type: LOGIN_FAILURE,
    payload: error
});

export const login2faRequired = data => ({
    type: LOGIN_2FA_REQUIRED,
    payload: data
});


export const setInvitationCode = (code) => {
    const url = host + api.invitationCode + `/${code}`;

    return (dispatch) => {
        dispatch(setInvitationCodeStarted());

        return axios.get(url)
            .then((res) => {
                dispatch(setInvitationCodeSuccess(res));
                return res;
            })
            .catch((err) => {
                dispatch(setInvitationCodeFailure(err));
                throw err;
            });
    };
};

const setInvitationCodeStarted = () => ({
    type: SET_INVITATION_CODE_STARTED
});

export const setInvitationCodeSuccess = serverReport => ({
    type: SET_INVITATION_CODE_SUCCESS,
    payload: serverReport
});

export const setInvitationCodeFailure = error => ({
    type: SET_INVITATION_CODE_FAILURE,
    payload: error
});


export const logout = () => {
    let url = host + api.logout;
    const token = localStorage.getItem('b-token');

    return dispatch => {
        dispatch(logoutStarted());
        axios.post(url, null, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                localStorage.removeItem('b-token');
                dispatch(setTokenStatus(false));
                dispatch(setAuthorizationStatus(false));
                // dispatch(clearCabinetState());
            })
            .catch(err => {
                localStorage.removeItem('b-token');
                dispatch(setTokenStatus(false));
                dispatch(setAuthorizationStatus(false));
                dispatch(logoutFailure(err));
                // dispatch(clearCabinetState());
            });
    };
};

const logoutStarted = () => ({
    type: LOGOUT_STARTED
});

export const logoutSuccess = serverReport => ({
    type: LOGOUT_SUCCESS,
    payload: serverReport
});

export const logoutFailure = error => ({
    type: LOGOUT_FAILURE,
    payload: error
});


export const resendEmail = () => {
    let url = host + api.resendEmail;
    const token = localStorage.getItem('b-token');

    return dispatch => {
        dispatch(resendEmailStarted());
        axios.post(url, null, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                dispatch(resendEmailSuccess(res))
            })
            .catch(err => {
                dispatch(resendEmailFailure(err));
            });
    };
};

const resendEmailStarted = () => ({
    type: RESEND_EMAIL_STARTED
});

export const resendEmailSuccess = serverReport => ({
    type: RESEND_EMAIL_SUCCESS,
    payload: serverReport
});

export const resendEmailFailure = error => ({
    type: RESEND_EMAIL_FAILURE,
    payload: error
});


export const forgotPassword = (data) => {
    const url = host + api.forgotPassword;

    return (dispatch) => {
        dispatch(forgotPasswordStarted());

        return axios.post(url, data)
            .then((res) => {
                dispatch(forgotPasswordSuccess(res));
            })
            .catch((err) => {
                dispatch(forgotPasswordFailure(err?.response?.data?.errors));
            });
    };
};

const forgotPasswordStarted = () => ({
    type: FORGOT_PASSWORD_STARTED
});

export const forgotPasswordSuccess = serverReport => ({
    type: FORGOT_PASSWORD_SUCCESS,
    payload: serverReport
});

export const forgotPasswordFailure = error => ({
    type: FORGOT_PASSWORD_FAILURE,
    payload: error
});


export const resetPassword = (data) => {
    const url = host + api.resetPassword;

    return (dispatch) => {
        dispatch(resetPasswordStarted());

        return axios.post(url, data)
            .then((res) => {
                dispatch(resetPasswordSuccess(res));
            })
            .catch((err) => {
                dispatch(resetPasswordFailure(err?.response?.data?.errors));
            });
    };
};

const resetPasswordStarted = () => ({
    type: RESET_PASSWORD_STARTED
});

export const resetPasswordSuccess = serverReport => ({
    type: RESET_PASSWORD_SUCCESS,
    payload: serverReport
});

export const resetPasswordFailure = error => ({
    type: RESET_PASSWORD_FAILURE,
    payload: error
});


export const verifyLogin2fa = (formData) => {
    let url = host + api.auth2faVerify;

    return dispatch => {
        dispatch(login2faVerifyStarted());

        axios.post(url, formData)
            .then(res => {
                const response = res.data.response;

                localStorage.setItem('b-token', response.token);
                localStorage.setItem('b-auth-status', 'true');

                dispatch(login2faVerifySuccess(response));
                dispatch(loginSuccess(response));
                dispatch(setTokenStatus(true));
            })
            .catch(err => {
                dispatch(login2faVerifyFailure(err?.response?.data?.errors));
            });
    };
};

const login2faVerifyStarted = () => ({
    type: LOGIN_2FA_VERIFY_STARTED
});

export const login2faVerifySuccess = serverReport => ({
    type: LOGIN_2FA_VERIFY_SUCCESS,
    payload: serverReport
});

export const login2faVerifyFailure = error => ({
    type: LOGIN_2FA_VERIFY_FAILURE,
    payload: error
});

export const resetLogin2fa = () => ({
    type: LOGIN_2FA_RESET
});






